import React, { useState, useCallback } from 'react';
import { StyleSheet } from 'react-native';
import { Button, withTheme } from '@rneui/themed';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { CollectionItemType, } from "@annunciate/core";
import { FAIcon, Modal } from '../elements';
import { PurchaseOptions } from '../purchase';
import { usePurchaseables } from '../../hooks/purchase';
import { LogInLogOutButton } from '@annunciate/ui/dist/components/buttons/LogInLogOutButton';
const UnthemedBuyButton = ({ item, buttonStyle, titleStyle, iconStyle, }) => {
    const { isError, isPending, authenticatedAccess, products, subscriptions, rentals, } = usePurchaseables(item);
    const [isBuyOptionsVisible, setIsBuyOptionsVisible] = useState(false);
    const toggleBuyOptionsVisibility = useCallback(() => {
        setIsBuyOptionsVisible(!isBuyOptionsVisible);
    }, [isBuyOptionsVisible]);
    const { top } = useSafeAreaInsets();
    const label = [];
    if (authenticatedAccess.length > 0) {
        return (React.createElement(LogInLogOutButton, { buttonStyle: buttonStyle, titleStyle: titleStyle, containerStyle: styles.buttonContainer, icon: React.createElement(FAIcon, { name: "lock", style: iconStyle }) }));
    }
    if (products.length) {
        label.push('Buy');
    }
    if (subscriptions.length) {
        label.push('Subscribe');
    }
    if (rentals.length) {
        label.push('Rent');
    }
    if (!label.length && item.__typename === CollectionItemType.Content) {
        label.push('Buy', 'Subscribe');
    }
    if (!label.length && item.__typename === CollectionItemType.Collection) {
        return;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { buttonStyle: buttonStyle, containerStyle: styles.buttonContainer, titleStyle: titleStyle, onPress: toggleBuyOptionsVisibility, icon: React.createElement(FAIcon, { name: "lock", style: iconStyle }), title: label.join('/') }),
        React.createElement(Modal, { isVisible: isBuyOptionsVisible, onCloseModal: toggleBuyOptionsVisibility, onBackButtonPress: toggleBuyOptionsVisibility, onBackdropPress: toggleBuyOptionsVisibility, scrollable: true, style: {
                marginHorizontal: 'auto',
                maxHeight: '100%',
                marginTop: top,
            }, modalStyle: {
                justifyContent: 'flex-start',
            } },
            React.createElement(PurchaseOptions, { isError: isError, isLoading: isPending, products: products, subscriptions: subscriptions, rentals: rentals }))));
};
const styles = StyleSheet.create({
    buttonContainer: {
        alignItems: 'center',
        backgroundColor: 'transparent',
    },
});
export const BuyButton = withTheme(UnthemedBuyButton, 'BuyButton');
//# sourceMappingURL=BuyButton.js.map